<template>
  <div>
    <validation-observer ref="exameFisicoForm">
      <b-form @submit.prevent>
        <b-row>
          <!-- EG -->
          <b-col cols="12" lg="6">
            <b-form-group label="EG" label-for="v-eg">
              <b-form-input
                id="v-eg"
                v-model="exameFisico.eg"
                placeholder="Exemplo: 38 semanas"
                :disabled="disableForm"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Sinais e Sintomas"
              class="font-weight-bold mb-2 mt-2"
            >
              <b-row>
                <b-col cols="6" md="3">
                  <b-form-checkbox
                    v-model="exameFisico.dispneia"
                    name="dispneia"
                    :disabled="disableForm"
                  >
                    Dispneia
                  </b-form-checkbox>
                </b-col>
                <b-col cols="6" md="3">
                  <b-form-checkbox
                    v-model="exameFisico.cianose"
                    name="cianose"
                    :disabled="disableForm"
                  >
                    Cianose
                  </b-form-checkbox>
                </b-col>
                <b-col cols="6" md="3">
                  <b-form-checkbox
                    v-model="exameFisico.palidez"
                    name="palidez"
                    :disabled="disableForm"
                  >
                    Palidez
                  </b-form-checkbox>
                </b-col>
                <b-col cols="6" md="3">
                  <b-form-checkbox
                    v-model="exameFisico.edemas"
                    name="edemas"
                    :disabled="disableForm"
                  >
                    Edemas
                  </b-form-checkbox>
                </b-col>
                <b-col cols="6" md="3">
                  <b-form-checkbox
                    v-model="exameFisico.ictericia"
                    name="ictericia"
                    :disabled="disableForm"
                  >
                    Icterícia
                  </b-form-checkbox>
                </b-col>
                <b-col cols="6" md="3">
                  <b-form-checkbox
                    v-model="exameFisico.pulsosAnormais"
                    name="pulsos-anormais"
                    :disabled="disableForm"
                  >
                    Pulsos Anormais
                  </b-form-checkbox>
                </b-col>
                <b-col cols="6" md="3">
                  <b-form-checkbox
                    v-model="exameFisico.turgenciaJugular"
                    name="turgencia-jugular"
                    :disabled="disableForm"
                  >
                    Turgência Jugular
                  </b-form-checkbox>
                </b-col>
                <!-- Outros -->
                <b-col cols="12" lg="6">
                  <b-form-group label="Outros" label-for="v-outros">
                    <b-form-input
                      id="v-outros"
                      v-model="exameFisico.outros"
                      placeholder="Outras observações"
                      :disabled="disableForm"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="Ausculta Pulmonar"
              class="font-weight-bold mb-2 mt-2"
            >
              <b-row>
                <!-- Ausculta Pulmonar -->
                <b-col cols="12" lg="12">
                  <b-form-group
                    label="Status"
                    label-for="v-ausculta-pulmonar-status"
                  >
                    <b-form-input
                      id="v-ausculta-pulmonar-status"
                      v-model="parecer.exameFisico.auscultaPulmonar.status"
                      placeholder="Status (ex: normal, alterado)"
                      :disabled="disableForm"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="12" lg="12">
                  <b-form-group label="Descrição" label-for="v-descricao">
                    <b-form-textarea
                      id="v-descricao"
                      v-model="parecer.exameFisico.auscultaPulmonar.descricao"
                      placeholder="Descrição detalhada"
                      rows="3"
                      class="mt-1"
                      :disabled="disableForm"
                    />
                  </b-form-group>
                </b-col>

                <!-- Ausculta Cardíaca -->
                <b-col cols="12" lg="12">
                  <b-form-group label="Ausculta Cardíaca">
                    <b-row>
                      <b-col cols="6" md="4">
                        <b-form-group label="RC" label-for="v-rc">
                          <b-form-input
                            id="v-rc"
                            v-model="exameFisico.auscultaCardiaca.rc"
                            placeholder="RC"
                            :disabled="disableForm"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6" md="4">
                        <b-form-group label="FC" label-for="v-fc">
                          <b-form-input
                            id="v-fc"
                            v-model="exameFisico.auscultaCardiaca.fc"
                            placeholder="FC"
                            :disabled="disableForm"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="6" md="4">
                        <b-form-group label="BPM" label-for="v-bpm">
                          <b-form-input
                            id="v-bpm"
                            v-model="exameFisico.auscultaCardiaca.bpm"
                            placeholder="BPM"
                            :disabled="disableForm"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group
                          label="Descrição"
                          label-for="v-ausculta-cardiaca-descricao"
                        >
                          <b-form-textarea
                            id="v-ausculta-cardiaca-descricao"
                            v-model="exameFisico.auscultaCardiaca.descricao"
                            placeholder="Descrição detalhada"
                            rows="3"
                            class="mt-1"
                            :disabled="disableForm"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
                <b-col cols="12" lg="12">
                  <b-form-group label="Pressão Arterial">
                    <b-row>
                      <b-col cols="12" md="4">
                        <b-form-group
                          label="Sistólica"
                          label-for="v-pa-sistolica"
                        >
                          <b-form-input
                            id="v-pa-sistolica"
                            v-model="exameFisico.pa.sistolica"
                            placeholder="120"
                            type="number"
                            :disabled="disableForm"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group
                          label="Diastólica"
                          label-for="v-pa-diastolica"
                        >
                          <b-form-input
                            id="v-pa-diastolica"
                            v-model="exameFisico.pa.diastolica"
                            placeholder="80"
                            type="number"
                            :disabled="disableForm"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12" md="4">
                        <b-form-group label="Unidade" label-for="v-pa-unidade">
                          <b-form-input
                            id="v-pa-unidade"
                            v-model="exameFisico.pa.unidade"
                            placeholder="unidade"
                            :disabled="disableForm"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col cols="12">
                        <b-form-group label="Outros" label-for="v-pa-outros">
                          <b-form-textarea
                            v-model="exameFisico.pa.outrosDescricao"
                            :disabled="disableForm"
                            rows="3"
                            max-rows="6"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <ButtonsFormVue
            label-edit="Editar Exame Físico"
            label-save="Salvar Exame Físico"
            :disable-form="disableForm"
            :loading-button="loading"
            :permission-insert="verificarPermissao('ROLE_PROFISSIONAL')"
            :permission-edit="verificarPermissao('ROLE_PROFISSIONAL')"
            @save="salvar"
            @edit="editar"
            @cancel="beforeCancelar"
          />
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import {
  BButton,
  BFormGroup,
  BFormCheckbox,
  BFormTextarea,
  BModal,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormSelect,
} from "bootstrap-vue";
import ButtonsFormVue from "@/layouts/components/ButtonsForm.vue";
import mixinsGlobal from "@/mixins";
export default {
  props: {
    parecer: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixinsGlobal],
  components: {
    AppCollapseItem,
    BButton,
    BFormGroup,
    BFormCheckbox,
    BFormTextarea,
    BModal,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormSelect,
    ValidationProvider,
    ValidationObserver,
    ButtonsFormVue,
  },
  data() {
    return {
      loading: false,
      disableForm: true,
      exameFisico: {
        eg: null,
        dispneia: false,
        cianose: false,
        palidez: false,
        edemas: false,
        ictericia: false,
        pulsosAnormais: false,
        turgenciaJugular: false,
        outros: null,
        auscultaPulmonar: {
          status: null,
          descricao: null,
        },
        auscultaCardiaca: {
          rc: null,
          fc: null,
          bpm: null,
          descricao: null,
        },
        pa: {
          sistolica: null,
          diastolica: null,
          unidade: null,
          outrosDescricao: null,
        },
      },
      unidadeOptions: [
        { value: null, text: "Selecione a unidade" },
        { value: "mmHg", text: "mmHg" },
        { value: "cmH2O", text: "cmH2O" },
      ],
    };
  },
  watch: {
    parecer: {
      handler(newVal) {
        if (newVal && newVal.exameFisico) {
          this.setExameFisicoData(newVal);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    beforeCancelar() {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm("Deseja realmente sair do cadastro do atendimento?", {
          title: "Confirmação",
          size: "sm",
          okVariant: "primary",
          okTitle: "Sim",
          cancelTitle: "Não",
          cancelVariant: "outline-secondary",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxTwo = value;
          if (value) {
            this.cancelar();
          }
        });
    },
    cancelar() {
      this.disableForm = true;
      this.loadingCampos = false;
      this.setExameFisicoData(this.parecer);
      this.$refs.exameFisicoForm.reset();
      this.$emit("disable-form-changed", this.disableForm);
    },
    async editar() {
      this.disableForm = false;
      this.$emit("disable-form-changed", this.disableForm);
    },
    salvar(isAutoSave = false) {
      this.$refs.exameFisicoForm.validate().then((success) => {
        if (success) {
          this.loading = true;
          try {
            this.$store
              .dispatch(
                "parecerCardiologicoModule/salvarExameFisico",
                this.exameFisico
              )
              .then((response) => {
                this.exameFisico = {
                  id: response.data.id,
                  ...response.data.exameFisico,
                };
                this.disableForm = true;
                this.showMessageSuccess(
                  "Editar",
                  "Exame Fisico Editado com sucesso!"
                );
                this.$emit("disable-form-changed", this.disableForm);
              });
          } catch (error) {
            this.MensagemError("Salvar", "Falha ao salvar!");
          } finally {
            this.loading = false;
          }
        }
      });
    },
    getExameFisicoData() {
      return this.exameFisico;
    },
    setExameFisicoData(data) {
      if (data && data.exameFisico) {
        this.exameFisico = {
          id: data.id,
          ...this.exameFisico,
          ...data.exameFisico,
        };
      }
    },
  },
};
</script>
